import Pager from '@/shared/pager/pager';

export default {
  build: () => {
    const keysToSearch = [
      'name',
      'emailManager',
      'statusManager',
      'statusManagerEs'

    ];

    const exportDefinitions = [
      // { value: 'id', label: 'id' },
      { value: 'name', label: 'name' },
      { value: 'emailManager', label: 'emailManager' },
      // { value: 'created', label: 'created' },
      // { value: 'modified', label: 'modified' }
    ];

    return new Pager(keysToSearch, exportDefinitions);
  }
};



// WEBPACK FOOTER //
// ./src/entities/club/club-pager.js